/** Module-level constants for projections */
export const ARCHIVED_CATEGORY_ID = 'archived';
export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
/** Type for showing trend compared to previous month */
export var TrendType;
(function (TrendType) {
    TrendType["HIGHER"] = "HIGHER";
    TrendType["LOWER"] = "LOWER";
    TrendType["NONE"] = "NONE";
})(TrendType || (TrendType = {}));
/** Enum defining the temporal status of a month */
export var MonthStatus;
(function (MonthStatus) {
    MonthStatus["PAST"] = "PAST";
    MonthStatus["CURRENT"] = "CURRENT";
    MonthStatus["FUTURE"] = "FUTURE";
})(MonthStatus || (MonthStatus = {}));
/**
 * Determines the temporal status of a month
 * @param year - The year of the month
 * @param monthIndex - The index of the month (0-11)
 * @param currentYear - The current year
 * @param currentMonthIndex - The current month index (0-11)
 * @returns The temporal status of the month
 */
export function determineMonthStatus(year, monthIndex, currentYear, currentMonthIndex) {
    if (year < currentYear) {
        return MonthStatus.PAST;
    }
    else if (year > currentYear) {
        return MonthStatus.FUTURE;
    }
    else {
        // Same year
        if (monthIndex < currentMonthIndex) {
            return MonthStatus.PAST;
        }
        else if (monthIndex > currentMonthIndex) {
            return MonthStatus.FUTURE;
        }
        else {
            return MonthStatus.CURRENT;
        }
    }
}
/**
 * Calculates the trend between current and previous monetary values with proper rounding
 * to avoid floating point precision issues common in financial calculations.
 *
 * Money values are rounded to 2 decimal places (cents) before comparison to ensure
 * accurate trend detection. For example, 10.004 and 10.006 would both round to 10.00
 * and be considered equal rather than showing a false trend.
 *
 * @param current - Current monetary value to compare
 * @param previous - Previous monetary value to compare against
 * @returns Trend type indicating the relationship between the rounded values
 * @internal
 */
export function calculateTrend(current, previous) {
    // Round both values to 2 decimal places (cents) to avoid floating point precision issues
    const roundedCurrent = Math.round(current);
    const roundedPrevious = Math.round(previous);
    if (roundedCurrent > roundedPrevious) {
        return TrendType.HIGHER;
    }
    else if (roundedCurrent < roundedPrevious) {
        return TrendType.LOWER;
    }
    else {
        return TrendType.NONE;
    }
}
